import { styled } from '@styles/stitches.config';

export const Box = styled('div', {});
